import { createThemeFromColor } from './custom'

export const theme = createThemeFromColor(
  '#FFFFFF',
  'light-white',
  'Light White',
  {
    tintColor: '#1F3247',
  },
)
